/**
 * @copyright Chianyu Inc., 2018 and onwards
 * @author Shengyi Liu
 * @date  2018/7/6 15:54
 * @des i18n
 */
import VueI18n from 'vue-i18n'
import {getItem} from './store/storage'
import {getJsBundleQueryData} from './util/urlutil'

export const LAN_CN = 'cn'
export const LAN_EN = 'en'

var i18n
var inited = false

function createVueI18n (messages) {
  if (!i18n) {
    let locale = getSystemLan()
    let i18nSaved = getItem('locale')
    if (i18nSaved && locale !== i18nSaved) {
      if (i18nSaved === LAN_CN || i18nSaved === LAN_EN) {
        locale = i18nSaved
      }
    }
    let params = getJsBundleQueryData()
    let paramLocale = params ? params['locale'] : ''
    if (paramLocale === LAN_CN || paramLocale === LAN_EN) {
      locale = paramLocale
    }
    i18n = new VueI18n({
      locale: locale, // 初始化默认的语言
      messages // 国际化字符集
    })
  }
  return i18n
}

function getSystemLan () {
  let lang = navigator.language || navigator.userLanguage
  lang = lang.substr(0, 2)
  if (lang === 'en') {
    return LAN_EN
  } else {
    return LAN_CN
  }
}

/**
 * 创建i18n
 */
export function create (Vue, messages) {
  if (inited) {
    return
  }
  inited = true

  Vue.use(VueI18n)
  createVueI18n(messages)
  Vue.prototype._i18n = i18n
}

export function getI18n () {
  return i18n
}

/**
 * 设置语言
 * @param {} local
 */
export function setLocal (local) {
  if (i18n) {
    i18n.local = local
  }
}

/**
 * 获取语言
 */
export function getLocal () {
  if (i18n) {
    return i18n.locale
  }
  return ''
}

/**
 * 是否是en语言环境
 */
export function isLocalEn () {
  return getLocal() === 'en'
}

/**
 * 获取国际化字符串
 * @param path
 * @returns {*}
 */
export function t (path, data = {}) {
  if (i18n) {
    return i18n.t(path, data)
  }
  return ''
}



// WEBPACK FOOTER //
// ./src/base/i18n.js